import Header from "@/components/hotel/Header";
import SubpageHero from "@/components/hotel/SubpageHero";
import BookingPolicy from "@/components/hotel/BookingPolicy";
import Footer from "@/components/hotel/Footer";
import SEO from "@/components/SEO";
import { useLanguage } from "@/i18n/LanguageContext";

const BookingPolicyPage = () => {
  const { t } = useLanguage();
  return (
    <main id="main-content" className="min-h-screen bg-background">
      <SEO
        title="Buchungsrichtlinien"
        description="Stornierungsbedingungen, Check-in/Check-out Zeiten und Buchungsrichtlinien des ESOS Hotel Quelle Bad Ragaz."
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Buchungsrichtlinien", path: "/booking-policy" },
        ]}
      />
      <Header />
      <SubpageHero title={t.subpageHeroes.bookingPolicy.title} subtitle={t.subpageHeroes.bookingPolicy.subtitle} />
      <BookingPolicy />
      <Footer />
    </main>
  );
};

export default BookingPolicyPage;
